<template>

  <div class="row" id="story">
    <div class="col-md-12">
      
      <Scrollama
        :debug="true"
        :offset="0.5"
        @step-enter="({ element }) => (currStep = element.dataset.stepNo)"
        @step-exit="({ element }) => (currStep = null)"
        >
        <div
          v-for="n in 4"
          :key="n"
          class="step"
          :data-step-no="n"
          :class="{ active: n == currStep }"
        >
          step {{ n }}
        </div>
      </Scrollama>

      <Scrollama
        :offset="0.5"
        :debug="true"
        @step-enter="({ element }) => (currStep = element.dataset.stepNo)"
        @step-exit="({ element }) => (currStep = null)"
        :progress="true"
        @step-progress="({ progress }) => (currStepProgress = progress)"
      >
        <div
          v-for="n in 4"
          :key="n"
          class="step"
          :data-step-no="n"
          :class="{ active: n == currStep }"
        >
          <div>step {{ n }}</div>
          <div>{{ Math.round(currStepProgress * 100) }}%</div>
        </div>
      </Scrollama>

    </div>
  </div>

</template>

<script>

import Vue from 'vue'
import "intersection-observer";
import Scrollama from "vue-scrollama";

export default {
  /**
  * Init data properties
  */
  components : {
    Scrollama
  },
  data: () => ({
    intersectionOptions: {
      root: null,
      rootMargin: '0px 0px 0px 0px',
      threshold: [0, 1] // [0.25, 0.75] if you want a 25% offset!
    }, 
    intersectionOptions1b : {
      root: null,
      rootMargin: '185px 0px 0px 0px',
      threshold: [0,1]
    },
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API,
    slides : [],
    cars : {} , 
    colors : ['#c0a9b0','#7880b5','#6987c9','#6bbaec','#483c46','#3c6e71','#70ae6e','#f4743b','#e3170a','#e16036','#f9dc5c'], 
    layout : { width_half : 0 , height : 0 },
    currStep: null , 
    currStepProgress: null
  }),
  /**
  * Event mounted
  */
  mounted(){
    // Animate On Scroll Library init
    AOS.init();
  },
  /**
  * Event created
  */
  created(){
    // console.log("this.slides",this.slides) ; 
  },
  /**
  * Methods
  */
  methods: {
    
  }
}

</script>

<style lang="scss">

$font_size : 1.4em ; 
$dark_color: #151A2F;
$light_color: #fff ;

.white{
  a{
    color: $dark_color ; 
  }
}

.dark{
  a{
    color: $light_color ; 
  }
  .story_marker{
    color: $dark_color ; 
  }
}

ul.pager{
  position: fixed ; 
  display: none ; 
  top: 50% ; 
  left: 20px ; 
  width: 30px ; 
  margin-top:-90px;
  z-index: 2 ; 
  li{
    margin-bottom: 15px ; 
    list-style-type: none ; 
    a{
      width: 15px ; 
      height: 15px ; 
      display: block ; 
      background: transparent;
      border-radius: 10px ; 
      border:solid 2px #fff ; 
      text-decoration: none;
      &.selected{
        background: #fff ;
      }
    }
  }
}

h1#main_title{

}

h2{
  font-size: 1.8em!important;
  font-weight: 900;
  padding-top: 50px;
  &.sticky{
    top: 50px ; 
    left: 0;
  }
}

h3{
  font-size: 1.6em!important; 
  font-weight: 800;
}

h4{
  font-size: 1.4em!important; 
  font-weight: 700;
}

header {
  height: 100vh;
  background: DarkSalmon ; 
}

.sidebar{
  background: pink;
  height: 350px ; 
  padding: 20px ;
}

#story{

  .step {
    padding: 15vh 0;
    width: 50%;
    margin: 0 auto 30vh;
    background-color: beige;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .step.active {
    background-color: teal;
    color: white;
  }

  .slide{
    height: 100vh ; 
    width: 100% ; 
    float: left; 

    h2{
      height: 10vh;
      display: block;
      width: 100%;
    }

    p.desc{
      height: 5vh;
      display: flex;
      width: 100%;
    }

    .viz_left,.viz_right{
      height: 50vh ; 
      min-width: 600px ; 
      background: #ccc ;
      position: relative ;
      will-change: position ;
    }
  }

  $top_fixed: 185px ;

  #section_1{
    height: 250vh; 
  }

  #section_1_a.viz_left{
    &.fixed{
      position: fixed ;
      top: $top_fixed ; 
    }
  }

  #section_1_b.viz_right{
    margin-top: 100vh;
    &.fixed{
      position: fixed ;
      top: $top_fixed ; 
    }
  }

  #section_1_c{
    height: 50vh; 
  }

}

footer{
  background: green ; 
  height: 300px ; 
}

</style>
